import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import divideOnPages from "_helpers/divideOnPages";

import Pagination from "components/Pagination/Pagination";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  max-width: 100%;
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 16px;
  color: #7b848d;
`;
const Body = styled.div``;
const Event = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  border-bottom: 1px solid #ecedf1;
  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }
`;
const Date = styled.div`
  display: flex;
  min-height: 32px;
`;
const Desc = styled(Date)`
  font-size: 14px;
`;

function EventInfo({ index, code, type, descriptionText, date, number }) {
  return (
    <Event index={index}>
      <Date>{date}</Date>
      <Desc>
        {number} - {code}, {type}: {descriptionText}
      </Desc>
    </Event>
  );
}

EventInfo.propTypes = {
  index: PropTypes.number,
  code: PropTypes.string,
  type: PropTypes.string,
  descriptionText: PropTypes.string,
  date: PropTypes.string,
  number: PropTypes.number,
};

function EventListMobile({ events, currentPage, changePage }) {
  const contentRef = useRef(null);

  if (!events && !Array.isArray(events)) return null;

  const pages = divideOnPages(events, 8);
  const result = pages[currentPage - 1];

  const handleChangePage = (page) => {
    if (page !== currentPage) {
      changePage(page);
      contentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container>
      {events.length ? (
        <>
          <Title ref={contentRef}> {events.length ? "Events" : "No Events"}</Title>
          <Body>
            <Pagination top currentPage={currentPage} totalPages={pages.length} onClick={handleChangePage} />
            {result.map((event, idx) => (
              <EventInfo key={idx} index={idx} {...event} />
            ))}
          </Body>
        </>
      ) : (
        <Title>No Events</Title>
      )}
    </Container>
  );
}

EventListMobile.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  currentPage: PropTypes.number,
  changePage: PropTypes.func,
};

export default EventListMobile;
